export default "__VITE_PUBLIC_ASSET__578600e0__"